import React from 'react'
import './Notification.css'
// import Header2 from '../../components/header/Header2';
import Breadcrumb from '../../components/breadcrumb';
import Footer from '../../components/footer';
import Gotop from '../../components/gotop';
import FaqItem from '../../components/faq';
import dataFaq from '../../assets/fakeData/dataFaq';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/images/logo.png"
import { useState } from "react";
import { Link } from "react-router-dom";
import LoginHeader from '../../components/header/LoginHeader';
import NotificationList from './NotificationList';
import LoginMobileHeader from '../../components/header/LoginMobileHeader';
import InstituteMobileHeader from '../../components/header/InstituteMobileHeader';
import CRMobileHeader from '../../components/header/CRMobileHeader';
import MobileHeader from '../../components/header/MobileHeader';
import InstituteHeader from '../../components/header/InstituteHeader';
import CRHeader from '../../components/header/CRHeader';
import NonLoginHeader from '../../components/header/NonLoginHeader';
import { Helmet } from 'react-helmet';
// import Header4 from "../components/header/Header4";

function Notification() {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const module = localStorage.getItem('Module')

  return (
    <>
         <Helmet>
				<title>Notifications | Jobkikhoj</title>
				<meta name="description" content=" " />
				<meta name="keywords" content=" " />
				<meta property="og:title" content="Notifications | Jobkikhoj " />
				<meta property="og:description" content="" />
				<meta property="og:url" content="https://jobkikhoj.com" />
			</Helmet>
       {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader clname="applications" handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader clname="applications" handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader clname="applications" handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader clname="applications" handleMobile={handleMobile} /> :
                            <NonLoginHeader clname="applications" handleMobile={handleMobile} />}

      <div className="pt-70">
      <NotificationList data={dataFaq} />
      {/* <Footer /> */}
      <Gotop />
      </div>
    </>
  )
}

export default Notification
